import { render, staticRenderFns } from "./Automotive.vue?vue&type=template&id=7ec9451e&lang=pug&"
import script from "./Automotive.vue?vue&type=script&lang=js&"
export * from "./Automotive.vue?vue&type=script&lang=js&"
import style0 from "./Automotive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports